import { CheckButton } from '@apply/components';
import { useBorrowerEsignAcknowledgeFont, useBorrowerEsignTypedName, useBorrowerEsignTitle, useBorrowerEsignDate, useBorrowerEsignIpAddress } from '../../../../../queries/BorrowerFields/EsignFields';
import { useBorrowerLoanType } from '../../../../../queries/BorrowerFields/CoreFields';
import { LoanType } from '../../../../../../../../admin/src/loans/common/LoanConstants';
import { constructAgreementHtml } from './../../functions/constructAgreementHtml';

interface AgreeAcknowledgementParameters {
    width?: string;
    set_acknowledgeHtml: React.Dispatch<React.SetStateAction<string | null>>;
}

export const AgreeAcknowledgement: React.FC<AgreeAcknowledgementParameters> = ({ set_acknowledgeHtml, width = 'auto' }) => {
    const [esignAcknowledgeFont, set_esignAcknowledgeFont] = useBorrowerEsignAcknowledgeFont();
    const [loanType] = useBorrowerLoanType();
    const [typedName] = useBorrowerEsignTypedName();
    const [title] = useBorrowerEsignTitle();
    const [date] = useBorrowerEsignDate();
    const [ipAddress] = useBorrowerEsignIpAddress();

    const onClickAcknowledgement = () => {
        if (esignAcknowledgeFont) {
            set_esignAcknowledgeFont(null);
            return;
        }

        const template = loanType == LoanType.Rental ? rentalAcknowledgementTemplate : generalAcknowledgementTemplate;
        set_acknowledgeHtml(constructAgreementHtml(template, typedName ?? '', title ?? '', date ?? '', undefined, ipAddress ?? ''));
    };

    return (
        <CheckButton
            id='agree-acknowledgment'
            label='Acknowledgement'
            selected={!!esignAcknowledgeFont}
            onToggle={onClickAcknowledgement}
            width={width}
        />
    );
};

const generalAcknowledgementTemplate = `
<p>I have prepared and reviewed this application. I hereby certify and represent that all of statements are accurate to the best of my knowledge. I
authorize Builder Finance Inc. and its affiliates to obtain references for the business and principals associated with this loan, including contacting
any of the parties (a) listed as part of this submission for whom a phone number is requested and/or (b) listed on any other form as a reference.</p>

<p>I hereby certify, represent, and warrant that the property is being built for commercial purposes: it is intended for arm's length sale or rental
to a third party, and the individuals comprising the current ownership will not occupy the property or otherwise allow it to be used personally until
the requested BFI loan has been paid off in full.</p>

<p>Signature: {{#SIGNATURE}}<br/>
Name: {{#NAME}}<br/>
Title: {{#TITLE}}<br/>
Date: {{#DATE}}<br/>
IP Address: {{#IPADDRESS}}</p>
`;

export const rentalAcknowledgementTemplate = `
<p>I have prepared and reviewed this application. I hereby certify and represent that all of statements are accurate to the best of my knowledge. I
hereby certify, represent, and warrant that the property is owned and operated for commercial purposes and that it is, and will be, rented to arm's
length third party(ies) and that individual(s) comprising the current ownership will not occupy the property or otherwise allow it to be used
personally.</p>

<p>Signature: {{#SIGNATURE}}<br/>
Name: {{#NAME}}<br/>
Title: {{#TITLE}}<br/>
Date: {{#DATE}}<br/>
IP Address: {{#IPADDRESS}}</p>
`;
